module.exports = __webpack_public_path__ + "img/facebook.0babb654.svg";